import { useState } from "react";
import Layout from "../../../components/custom/Layout";
import { Newsletter } from "../../../globals/interfaces";
import apiClient from "../../../apiClient";
import useSWR from "swr";
import VirtualTable from "../../../components/custom/VirtualTable";
import styled from "styled-components";
import ActionIcon from "../../../components/custom/ActionIcon";
import ModalManageNewsletter from "./ModalManageNewsletter";
import { useAppContext } from "../../../context";
import _ from "lodash";

const fetcher = async (endpoint: string): Promise<Array<Newsletter>> => {
    try {
        const res = await apiClient.get(endpoint);
        return res.data;
    } catch (err) {
        return [];
    }
}

export default function ManageNewsletter () {

    const { user } = useAppContext();
    const {
        data,
        mutate
    } = useSWR(`/newsletter`, fetcher, {
        fallbackData: []
    });

    const [modal, setModal] = useState(false);
    const [item, setItem] = useState<Newsletter>();

    const handleManage = (item?: Newsletter) => {
        setItem(item);
        setModal(true);
    }

    const createNewsletter = async (newItem: Newsletter) => {
        try {
            const res = await apiClient.post(`/newsletter`, newItem);
            const created = res.data;
            const newData = [created, ...data]
            mutate(newData);
        } catch (err) {
            alert(err);
        }
    }

    const updateNewsletter = async (updateItem: Newsletter) => {
        try {
            const res = await apiClient.put(`/newsletter`, updateItem);
            const updated = res.data;
            const updateIndex = data.findIndex(item => item.id === updateItem.id);
            const copy = _.cloneDeep(data);
            copy[updateIndex] = updated;
            mutate(copy);
        } catch (err) {
            alert(err);
        }
    }

    const deleteNewsletter = async (id: number) => {
        try {
            const res = await apiClient.delete(`/newsletter/${id}`);
            const updatedData = data.filter(item => item.id !== id);
            mutate(updatedData);
        } catch (err) {
            alert(err);
        }
    }


    return (
        <Layout>
            <FlexContainer>
                <h1>Manage Newsletter</h1>
                <ActionIcon type={'add'} onClick={handleManage} />
            </FlexContainer>
            <VirtualTable 
                data={data}
                mapping={[{
                    name: 'Name',
                    value: 'name'
                }, {
                    name: 'Year',
                    value: 'year'
                }, {
                    name: 'Issue',
                    value: 'issue'
                }, {
                    name: 'Created By',
                    value: 'createdBy',
                    email: true
                }, {
                    name: 'Created At',
                    value: 'createdAt',
                    datetime: true,
                    utc: true
                }]}
                numRows={10}
                handleClick={item => handleManage(item)}
            />
            <ModalManageNewsletter 
                modal={modal}
                setModal={setModal}
                user={user}
                data={data}
                item={item}
                createNewsletter={createNewsletter}
                updateNewsletter={updateNewsletter}
                deleteNewsletter={deleteNewsletter}
            />
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;